import React from 'react';
import {
  DEFAULT_LOCALE,
  AA_COOKIE_BANNER_SCRIPT,
  IS_ADMIN_PERMISSION,
  AA_DCF_SCRIPT,
  DCF_JQUERY_SCRIPT,
  AIRLINES,
  AA_FOP_SCRIPT,
  BOOK_TRAVEL_URLS,
  HELP_URLS,
  TRIPIT_LINKS,
  TERMS_AND_CONDITIONS_LINKS,
  REACT_APP_POLICY_LINKS,
  REACT_APP_BASIC_ECONOMY_LINK,
  MANAGE_TRIP_LINKS,
  TAX_ID_REGEXES,
  REACT_APP_MANAGING_TRAVEL_POLICY_LINKS,
  ACCEPTED_LANGUAGES,
} from '../constants/appConstants';
import { FormattedMessage } from "react-intl";
import { storageFactory } from "factory/storageFactory";
import { Spanish } from "flatpickr/dist/l10n/es.js";
import { French } from "flatpickr/dist/l10n/fr.js";
import { Portuguese } from "flatpickr/dist/l10n/pt.js";
import { German } from "flatpickr/dist/l10n/de.js";
import { Italian } from "flatpickr/dist/l10n/it.js";
import { Japanese } from "flatpickr/dist/l10n/ja.js";
import { Mandarin } from "flatpickr/dist/l10n/zh.js";
import { Czech } from "flatpickr/dist/l10n/cs.js";
import { Norwegian } from "flatpickr/dist/l10n/no.js";
import { Swedish } from "flatpickr/dist/l10n/sv.js";
import { Korean } from "flatpickr/dist/l10n/ko.js";
import { Arabic } from "flatpickr/dist/l10n/ar.js";
import { Polish } from "flatpickr/dist/l10n/pl.js";
import { Default } from "flatpickr/dist/l10n/default.js";
import moment from 'helpers/moment';

const localStore = storageFactory(() => localStorage);
const sessionStore = storageFactory(() => sessionStorage);
export const getLang = () => ACCEPTED_LANGUAGES[localStore.getItem("locale") || DEFAULT_LOCALE];

export const nameInitials = name => {
  const nameSplit = name?.split(" ");
  const initials = nameSplit.shift().charAt(0) + nameSplit.pop().charAt(0);
  return initials.toUpperCase();
};

export const formatBytes = (b) => {
  const units = ['bytes', 'kB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']
  let l = 0
  let n = b

  while (n >= 1024) {
    n /= 1024
    l += 1
  }

  return `${n.toFixed(n >= 10 || l < 1 ? 0 : 1)} ${units[l]}`
}

export const formatDuration = (seconds) => {
  const date = new Date(0)
  date.setSeconds(seconds)
  const dateString = date.toISOString().slice(11, 19)
  if (seconds < 3600) return dateString.slice(3)
  return dateString
}

export const getCookieValue = (name) => (
  document.cookie.match('(^|;)\\s*' + name + '\\s*=\\s*([^;]+)')?.pop() || ''
)

export const getAssociatedLang = lang => {
  return ACCEPTED_LANGUAGES[lang || DEFAULT_LOCALE]
}

export const getAssociatedLangCookie = lang => {
  switch (lang) {
    case "es_ES":
      return "es";
    case "pt_PT":
    case "pt_BR":
      return "pt";
    case "fr_FR":
    case "fr_CA":
      return "fr";
    default:
      return "en_US";
  }
}

export const injectDomainRelatedScripts = (airline, lang) => {

  switch(airline) {
    case AIRLINES.AA:
      if (AA_COOKIE_BANNER_SCRIPT && !isScriptLoaded(AA_COOKIE_BANNER_SCRIPT)) {
        //inject cookie banner root component
        const markup = document.createElement('adc-cookie-banner');
        markup.locale = getAssociatedLangCookie(lang)
        document.body.appendChild(markup);

        //inject cookie banner script
        const cookieBannerScript = document.createElement('script');
        cookieBannerScript.src = AA_COOKIE_BANNER_SCRIPT;
        cookieBannerScript.type = 'module';
        cookieBannerScript.async = true;
        document.head.appendChild(cookieBannerScript);
      }

      if (AA_DCF_SCRIPT && !isScriptLoaded(AA_DCF_SCRIPT)) {
        //inject cookie banner script
        const scriptjQuery = document.createElement('script');
        scriptjQuery.src = DCF_JQUERY_SCRIPT;
        scriptjQuery.async = true;
        scriptjQuery.crossorigin = "anonymous";
        document.head.appendChild(scriptjQuery);

        //inject dcfsmartwebservice root component
        const dcfsmartwebservice = document.createElement('dcf-smartweb-service');
        document.head.appendChild(dcfsmartwebservice);

        //inject dcfsmartwebservice script
        const scriptsmartwebservice = document.createElement('script');
        scriptsmartwebservice.src = AA_DCF_SCRIPT;
        scriptsmartwebservice.type = 'module';
        scriptsmartwebservice.async = true;
        document.head.appendChild(scriptsmartwebservice);
      }

      if(AA_FOP_SCRIPT && !isScriptLoaded(AA_FOP_SCRIPT)) {
        const scriptjQuery = document.createElement('script');
        scriptjQuery.src = AA_FOP_SCRIPT;
        scriptjQuery.async = true;
        scriptjQuery.crossorigin = "anonymous";
        document.head.appendChild(scriptjQuery);
      }
    break;
    case AIRLINES.UC:
      //
    break;
  }
}

export const isScriptLoaded = url =>  {
  const scripts = document.getElementsByTagName('script');
  for (let i = scripts.length; i--;) {
    if (scripts[i].src === url) return true;
  }
  return false;
}

export const isAdmin = (userContext) =>  {
  return userContext.manageCompany ? false : userContext?.userInfo?.permissions?.includes(IS_ADMIN_PERMISSION);
}

export const commasFormat = (value) => {
  return value?.replace(/\D/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, ",");
};

export const saveCurrentLocation = location => {
  const prev = localStore.getItem("prevLocations")
  let locations = prev ? JSON.parse(prev) : [];

  if(locations) {
    if(locations[locations.length - 1] !== location) {
      if(locations.length >= 3) {
        //delete first element
        locations.splice(0, 1)
      }
      //do not add if the last entri is the same as the one that you are about to insert
      locations.push(location);
    }
  } else {
    locations = [location]
  }

  localStore.setItem("prevLocations", JSON.stringify(locations));
}

export const bookTravelUrl = airline => BOOK_TRAVEL_URLS[airline] || "";

export const getHelpUrl = airline => HELP_URLS[airline] || "";

export const getTripitLink = airline => TRIPIT_LINKS[airline] || "";
export const getTermsLink = airline => TERMS_AND_CONDITIONS_LINKS[airline] || "";
export const getPolicyLink = airline => REACT_APP_POLICY_LINKS[airline] || "";
export const getBasicEconomyLink = airline => REACT_APP_BASIC_ECONOMY_LINK[airline] || "";
export const getManageTripLinks = airline => MANAGE_TRIP_LINKS[airline] || "";
export const getManagingTravelPolicyLink = airline => REACT_APP_MANAGING_TRAVEL_POLICY_LINKS[airline] || "";


export const toReversedHelper = (arr) => {
  if (Object.prototype.toString.call(arr) !== '[object Array]') {
    return arr;
  }

  return arr.slice().reverse();
};

// function used in pending invites and activity feed to show time interval between two dates
export const formatTimeInterval= (inviteDate, messageKey, showValue = true) => {
  const firstDate = new Date(inviteDate + "Z");
  const secondDate = new Date();
  const differenceBtwDates = Math.abs(secondDate - firstDate) / 1000;

  const timeIntervals = {
    year: 31536000,
    month: 2592000,
    day: 86400,
    hour: 3600,
    minute: 60,
    second: 1,
  };

  for (let interval in timeIntervals) {
    const value = Math.floor(differenceBtwDates / timeIntervals[interval]);
    if (value >= 1) {
      const unit = value === 1 ? interval : `${interval}s`;
      return (
        <>
          {(interval !== "second" || showValue) && value} <FormattedMessage id={`${messageKey}.${unit}`} />
        </>
    );
    }
  }
};

export const getHeadersForCsv = (response, gridName, intl, columns) => {
  let headers = [];
  let header = null;

  if (response?.length > 0) {
    Object.keys(response[0]).forEach((responseheader) => {
      if (columns && columns[responseheader]?.customField) {
        header = responseheader;
      } else {
        header = intl.formatMessage({id: `${gridName}.${responseheader}`});
      }
      headers.push({key: responseheader, label: header});
    });
    return headers;
  } else {
    return []; // Return empty array instead of undefined
  }
};


export const getCurrencySymbol = (currencyCode) => {
  const currencySymbols = {
    USD: "$",
    CAD: "CA$",
    MXN: "MX$",
    EUR: "€",
    DKK: "kr",
    NOK: "kr",
    SEK: "kr",
    NZD: "NZ$",
    AUD: "A$",
    JPY: "¥",
    CNY: "¥",
    BRL: "R$",
    SAR: "﷼",
  };
  return currencySymbols[currencyCode] || "$";
};

// Currency locale mapping for number formatting
export const getCurrencyLocale = (currencyCode) => {
  const currencyLocales = {
    USD: "en-US",
    CAD: "en-CA",
    MXN: "es-MX",
    EUR: "de-DE",
    DKK: "da-DK",
    NOK: "nb-NO",
    SEK: "sv-SE",
    NZD: "en-NZ",
    AUD: "en-AU",
    JPY: "ja-JP",
    CNY: "zh-CN",
    BRL: "pt-BR",
    SAR: "ar-SA",
  };
  return currencyLocales[currencyCode] || "en-US";
};

export  const formatExpDate = (expirationMonth, expirationYear) => {
  let expDate = `${expirationMonth < 10 ? `0${expirationMonth}` : expirationMonth}/${expirationYear}`
  return expDate
}

export const moveByPriority = (arr, key) => {
  const priority = { "US": 1, "CA": 2 };
  return arr ? arr?.sort((a, b) => {
    const priorityA = priority[a?.[key]] || 3; // Default priority for other countries
    const priorityB = priority[b?.[key]] || 3;
    return priorityA - priorityB;
  }) : [];
};

export const cardText = cardType => {
  switch(cardType) {
    case "CA":
      return "Mastercard"
    case "VI":
      return "Visa"
    case "AX":
      return "Amex"
    case "DS":
      return "Discover"
    case "DC":
      return "Diners Club"
    case "TP":
      return "Universal Air Travel"
    case "JC":
      return "JCB"
    case "CU":
      return "China Union Pay"
    case "VIAS":
      return "Alaska Visa"
    case "AS":
      return "Alaska Commercial Account"
    default:
      break;
  }
}

// function used in pending invites to convert time based on params
export const convertTime= ( value, fromUnit, toUnit) => {
  const unitsToSeconds = {
    year: 31536000,
    month: 2592000,
    day: 86400,
    hour: 3600,
    minute: 60,
    second: 1,
  };

  // Check if the input units are valid
  if (!(fromUnit in unitsToSeconds) || !(toUnit in unitsToSeconds)) {
    throw new Error("Invalid units provided.");
  }
  // Convert the input value to seconds
  let valueInSeconds = value * unitsToSeconds[fromUnit];
  // Convert from seconds to the target unit
  let convertedValue = valueInSeconds / unitsToSeconds[toUnit];

  return convertedValue;
};

export const millisecondsToDaysRounded = (milliseconds) => {
  const days = milliseconds / (1000 * 60 * 60 * 24);
  const fractionalPart = days - Math.floor(days);

  if (fractionalPart >= 0.5) {
    return Math.ceil(days);
  } else {
    return Math.floor(days);
  }
}

export const transformTierName = (name) => {
  if (!name) return "";

  return name
    .replace(/^AAdvantage\s*/i, "")
    .replace(/[®©℠]+$/, "")
    .trim();
};

export const taxIdHelperMessageMap = {
    CA: "taxIdValidation.taxIDNote",
    US: "taxIdValidation.taxIDNote",
    BR: "taxIdValidation.note.BR",
    MX: "taxIdValidation.note.MX",
    AR: "taxIdValidation.note.AR",
    CO: "taxIdValidation.note.CO",
    PE: "taxIdValidation.note.PE",
    CL: "taxIdValidation.note.CL",
};

export const taxFieldValidation = (values) => {
  let error;

  const countriesSpecificRegex = {
    US: /^\d{9}$/, // US: 9 digits (without dash)
    CA: /^\d{9}$/, // Canada: 9 digits
    BR: /^\d{14}$/, // Brazil: 14 digits (CNPJ without separators)
    MX: /^[A-ZÑ&]{3}[0-9]{6}[A-Z0-9]{3}$/, // Mexico RFC (12 chars)
    AR: /^(20|23|24|27|30|33|34)\d{9}$/, // Argentina CUIT/CUIL: 11 digits with valid prefix
    CO: /^\d{9,10}$/, // Colombia NIT: 9–10 digits
    PE: /^\d{11}$/, // Peru RUC: 11 digits
    CL: /^\d{7,8}-[0-9Kk]$/, // Chile RUT: 7-8 digits + digit or K (with hyphen)
  };

  // remove dash and dots (expect Chile)
  let taxId =
    values.countryCode === "CL"
      ? values.taxId.trim()
      : values.taxId.replaceAll(/[-.\s]/g, "");

  const regex = countriesSpecificRegex[values.countryCode];
  if (regex && !regex.test(taxId)) {
    return <FormattedMessage id="taxIdValidation.taxMatches" />;
  }

  // Special check for Argentina (CUIT/CUIL) with modulo 11
  if (values.countryCode === "AR") {
    if (!isValidCUIT(taxId)) {
      return <FormattedMessage id="taxIdValidation.invalidChecksum" />;
    }
  }

  return error;
};

// CUIT modulo 11 validation for AR
const isValidCUIT = (cuit) => {
  if (!/^\d{11}$/.test(cuit)) return false;

  const digits = cuit.split("").map(Number);
  const checkDigit = digits.pop();

  const multipliers = [5, 4, 3, 2, 7, 6, 5, 4, 3, 2];
  const total = digits.reduce(
    (sum, digit, i) => sum + digit * multipliers[i],
    0
  );

  const remainder = total % 11;
  let expectedCheckDigit = 11 - remainder;

  if (expectedCheckDigit === 11) expectedCheckDigit = 0;
  if (expectedCheckDigit === 10) expectedCheckDigit = 9;

  return checkDigit === expectedCheckDigit;
}

export const getDismissableBannerKey = (providerCode) => {
  return `dismissable_${providerCode}_banner`
};

export const bannerPresent = (provider) => {
  const envVariable = {
    [AIRLINES.AA]: process.env.REACT_APP_DISPLAY_AA_ADVANTAGE_ALERT === "true" || process.env.REACT_APP_DISPLAY_ALERT === "true",
    [AIRLINES.AS]: process.env.REACT_APP_DISPLAY_AS_ALERT === "true",
  };

  if (AIRLINES[provider]) {
    return envVariable[provider] && sessionStore.getItem(getDismissableBannerKey(provider)) !== "dismissed";
  }

  return false;
};

//new threshold logic only if flag is "B"
export const showMilesThresholdChangesAA = (thresholdLogic = "B") => thresholdLogic === "B"

export const isWithinOneYear = (dateString) => {
  if (!dateString) return false;

  const targetDate = new Date(dateString);
  const today = new Date();

  today.setHours(0, 0, 0, 0);
  targetDate.setHours(0, 0, 0, 0);

  // Calculate one year from today to handle leap years correctly
  const oneYearFromToday = new Date(today);
  oneYearFromToday.setFullYear(today.getFullYear() + 1);

  return targetDate >= today && targetDate <= oneYearFromToday;
};

export const isNinetyOrLessDaysLeft = (dateString) => {
  if (!dateString) return false;

  const today = new Date();
  today.setHours(0, 0, 0, 0);

  const expirationDate = new Date(dateString);

  const diffInDays = Math.ceil((expirationDate - today) / (1000 * 60 * 60 * 24));

  return diffInDays <= 90;
};

export const isValidTaxId = (taxId, country) => {
  const regex = TAX_ID_REGEXES[country]?.regex;
  // if we do not have a validation defined, leave it pass
  if (!regex) return true;
  return regex.test(taxId.toUpperCase());
}

export const getFullLanguageText = (locale) => {
  switch (locale) {
    case 'EN':
    case 'en_AU':
    case 'en_CA':
    case 'en_DE':
    case 'en_ES':
    case 'en_FR':
    case 'en_IE':
    case 'en_IN':
    case 'en_IT':
    case 'en_MX':
    case 'en_NZ':
    case 'en_UK':
    case 'en_US':
    case 'en_XL':
      return <FormattedMessage id="loginPage.EN" />;
    case 'ES':
    case 'es_CA':
    case 'es_ES':
    case 'es_MX':
    case 'es_XL':
    case 'es_CO':
    case 'es_CL':
    case 'es_PE':
    case 'es_US':
    case 'es_AR':
      return <FormattedMessage id="loginPage.ES" />;
    case 'PT':
    case 'pt_PT':
      return <FormattedMessage id="loginPage.PT" />;
    case 'pt_BR':
    case 'PT-BR':
    case 'pt_US':
      return <FormattedMessage id="loginPage.PT-BR" />;
    case 'de_DE':
      return <FormattedMessage id="loginPage.DE" />;
    case 'ar_SA':
      return <FormattedMessage id="loginPage.SA" />;
    case 'cs_CZ':
      return <FormattedMessage id="loginPage.CZ" />;
    case 'FR':
    case 'FR-CA':
    case 'fr_CA':
    case 'fr_FR':
    case 'fr_US':
      return <FormattedMessage id="loginPage.FR" />;
    case 'it_IT':
      return <FormattedMessage id="loginPage.IT" />;
    case 'ja_JP':
      return <FormattedMessage id="loginPage.JP" />;
    case 'ko_KR':
      return <FormattedMessage id="loginPage.KR" />;
    case 'nb_NO':
      return <FormattedMessage id="loginPage.NO" />;
    case 'pl_PL':
      return <FormattedMessage id="loginPage.PL" />;
    case 'pt_XL':
      return <FormattedMessage id="loginPage.PT" />;
    case 'sv_SE':
      return <FormattedMessage id="loginPage.SE" />;
    case 'zh_CN':
      return <FormattedMessage id="loginPage.CN" />;
    default:
      return <FormattedMessage id="loginPage.EN" />;
  }
}

export const getCalendarLocale = (globalLocale) => {
  switch (globalLocale) {
    case "ES":
    case "es_US":
    case "es_XL":
    case "es_MX":
    case "es_ES":
    case 'es_CO':
    case 'es_CL':
    case 'es_PE':
    case 'es_AR':
      return Spanish;
    case "FR":
    case "FR-CA":
    case "fr_CA":
    case "fr_FR":
      return French;
    case "PT":
    case "pt_BR":
    case "PT-BR":
    case "pt_XL":
      return Portuguese;
    case "de_DE":
      return German;
    case "it_IT":
      return Italian;
    case "ja_JP":
      return Japanese;
    case "zh_CN":
      return Mandarin;
    case "cs_CZ":
      return Czech;
    case "nb_NO":
      return Norwegian;
    case "sv_SE":
      return Swedish;
    case "ko_KR":
      return Korean;
    case "ar_SA":
      return Arabic;
    case "pl_PL":
      return Polish;
    default:
      return Default;
  }
};

export const dateFormatWithLocale = (date, locale) => {

  if (!date || date === '0000-00-00 00:00:00') return '-';

  const m = moment(date, moment.ISO_8601, true);
  if (!m.isValid()) return '-';

  const normalizedLocale = locale?.replace('_', '-').toLowerCase();

  // If locale exists in moment → use localized format
  if (normalizedLocale && moment.locales().includes(normalizedLocale)) {
    return m.locale(normalizedLocale).format('L');
  }

  // Fallback → default US format
  return m.format('MM/DD/YYYY');
};

export const currencyFormatWithLocale = (amount, locale, currency) => {
  if (!locale) return String(Number(amount).toFixed(2));
  const normalizedLocale = locale?.replace('_', '-').toLowerCase();
  return String(
    new Intl.NumberFormat(normalizedLocale, { style: 'currency', currency: currency || 'USD', currencyDisplay: 'code' })
      .format(amount)
      .replace(currency || 'USD', '')
      .trim()
  );
};

const CA_STATES_FR = {
  AB: 'Alberta',
  BC: 'Colombie-Britannique',
  PE: 'Île-du-Prince-Édouard',
  MB: 'Manitoba',
  NB: 'Nouveau-Brunswick',
  NS: 'Nouvelle-Écosse',
  ON: 'Ontario',
  QC: 'Québec',
  SK: 'Saskatchewan',
  NL: 'Terre-Neuve-et-Labrador',
  NU: 'Nunavut',
  NT: 'Territoires du Nord-Ouest',
  YT: 'Yukon',
};

export const getFrenchLocalizedStates = (states, country, locale) => {
  if (country === 'CA' && locale === 'fr_CA') {
    return states.map((s) => ({ ...s, label: CA_STATES_FR[s.value] ?? s.label }));
  }
  return states;
};

export const getDefaultLocale = (providerCode) => {
  switch (providerCode) {
    case AIRLINES.AC:
      return 'en_CA';
    default:
      return DEFAULT_LOCALE;
  }
};

export const formatUTCDateTime = (utcString) => {
  if (!utcString) return '';
  const date = new Date(utcString);
  if (isNaN(date.getTime())) return '';
  return new Intl.DateTimeFormat(navigator.language, {
    year: 'numeric',
    month: 'numeric',
    day: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
    timeZoneName: 'short',
  }).format(date);
};

